import { MrtTable } from '@mi-front/ui';
import { Box, Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { EqualMd5Report } from './types';

export function EqualMd5ReportResult(p: ReportResultProps<EqualMd5Report>) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={p.result.items}
      columns={[
        {
          id: 'md5',
          header: $t({
            id: 'audit.equalMd5Report.md5',
            defaultMessage: 'Hash de Archivo',
          }),
          accessorKey: 'md5',
          size: 140,
        },
        {
          id: 'customIds',
          header: $t({
            id: 'audit.equalMd5Report.customIds',
            defaultMessage: 'IDs personalizados',
          }),
          accessorFn: (row) => row.audios.map((a) => a.customId).join(' '),
          Cell: ({ row }) => (
            <Box display={'flex'} flexWrap={'wrap'} gap={1}>
              {row.original.audios.map((a) => (
                <Chip key={a.customId} sx={{ fontWeight: '500' }} label={a.customId} />
              ))}
            </Box>
          ),
          minSize: 600,
          filterFn: 'contains',
        },
      ]}
    />
  );
}
